import React from 'react'
import { useTranslation } from 'react-i18next'

function AddSubscription() {
  const { t } = useTranslation(['subscriptions'])

  return (
    <a href={`${process.env.REACT_APP_WEPAPP_URL}/accounts/new-subscription`} className="pill-link" target="_blank" rel="noopener noreferrer">
      <i className="fas fa-plus icon-spacing"></i>
      <span>{t('buttons.add_subscription')}</span>
    </a>
  )
}

export default AddSubscription
